import React from "react";

/**
 * BrandMark — inline SVG monogram used in headers, footers and login.
 * Renders an amber arc "bridging" over a navy tile, subtly evoking
 * the Asia → Europe route Safeway Finland stands for.
 */
export default function BrandMark({ size = 36, className = "", withGlow = false }) {
  const uid = React.useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      role="img"
      aria-label="Safeway Finland"
      className={className}
    >
      <defs>
        <linearGradient id={`bg-${uid}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#111C33" />
          <stop offset="1" stopColor="#0B1424" />
        </linearGradient>
        <linearGradient id={`arc-${uid}`} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#FFB663" />
          <stop offset="1" stopColor="#F97316" />
        </linearGradient>
      </defs>
      {/* Rounded tile */}
      <rect x="0" y="0" width="40" height="40" rx="10" fill={`url(#bg-${uid})`} />
      {/* Faint horizon line — the "sea" between Asia and Europe */}
      <line x1="6" y1="27" x2="34" y2="27" stroke="#FFFFFF" strokeOpacity="0.08" strokeWidth="1" />
      {/* Left port dot (Asia) */}
      <circle cx="9" cy="27" r="1.6" fill="#F97316" />
      {/* Right port dot (Europe) */}
      <circle cx="31" cy="27" r="1.6" fill="#F97316" />
      {/* Amber bridge arc — the route */}
      <path
        d="M9 27 Q 20 6, 31 27"
        stroke={`url(#arc-${uid})`}
        strokeWidth="2.6"
        strokeLinecap="round"
        fill="none"
      />
      {withGlow && (
        <circle cx="20" cy="14" r="1.4" fill="#FFB663">
          <animate attributeName="opacity" values="0.4;1;0.4" dur="2.4s" repeatCount="indefinite" />
        </circle>
      )}
    </svg>
  );
}
